import env from "$/lib/env"
import { NotAdminError } from "$/lib/errors"
import { isClientStale } from "$/lib/is-client-stale"
import { createWebAuth } from "@repo/web-auth"
import { captureException, captureMessage, flush, setUser } from "@sentry/react"

export const webAuth = createWebAuth({
  appName: "Admin",
  apiUrl: env.VITE_API_URL,
  firebase: {
    apiKey: env.VITE_FIREBASE_API_KEY,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: env.VITE_FIREBASE_APP_ID,
  },
  authEmulatorHost: env.VITE_FIREBASE_AUTH_EMULATOR_HOST,
  isClientStale,
  reporter: {
    captureException: (error) => captureException(error),
    captureMessage: (message, context) => captureMessage(message, context),
    flush: (timeoutMs) => flush(timeoutMs),
    setUser: (user) => setUser(user),
  },
  onLogin: async (user) => {
    if (!user.isAdmin) throw new NotAdminError()
  },
})

export const {
  findIdToken,
  login,
  logout,
  getCurrentUser,
  reportTokenLostOnLoad,
} = webAuth
